const footerColumns = [
  {
    title: "内容导航",
    links: [
      { label: "首页", href: "/" },
      { label: "电影频道", href: "/category/movie" },
      { label: "电视剧频道", href: "/category/tv" },
      { label: "搜索影视", href: "/search" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", href: "/about" },
      { label: "发展愿景", href: "/about" },
      { label: "联系我们", href: "/contact" },
      { label: "意见反馈", href: "/contact" },
    ],
  },
  {
    title: "法律条款",
    links: [
      { label: "版权声明", href: "/about" },
      { label: "隐私政策", href: "/about" },
      { label: "免责声明", href: "/about" },
      { label: "用户协议", href: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 border-t border-primary-900/60">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-accent-500 text-background-50 flex items-center justify-center text-xl">
                <i className="ri-movie-2-fill" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">天堂电影网</span>
            </div>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-sm">
              天堂电影网是面向广大影迷的影视内容导航平台，为你汇集最新上映的电影与热播电视剧，提供分类筛选、搜索与个性化推荐，带来便捷流畅的浏览体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-900 text-foreground-300">
                <i className="ri-mail-line" aria-hidden="true" />
              </span>
              <div className="text-sm">
                <p className="text-foreground-300">联系邮箱</p>
                <p className="text-foreground-500">support@tiantang-movie.com</p>
              </div>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-semibold tracking-widest uppercase text-accent-400 mb-4">
                {col.title}
              </h3>
              <ul className="space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-400 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-900/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 天堂电影网 版权所有 · 本站内容仅供学习交流，不提供任何视听播放服务
          </p>
          <p className="text-xs text-foreground-500">本站所有影视资料均来源于公开信息，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}